<template>
  <BasicLayout>
    <template #wrapper>
      <el-card>
        <el-form :inline="true">
          <!--          <el-form-item label="平台" prop="platForm">-->
          <!--            <el-select v-model.number="queryParams1.platForm" size="small" style="width: 130px" placeholder="'请选择'">-->
          <!--              <el-option-->
          <!--                v-for="item in platForm"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams1.country" filterable size="small" style="width: 150px" placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="queryParams1.startDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>

      <template v-if="table">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="time"
            label="时间"
            width="180"
          />
          <el-table-column
            prop="today"
            label="今日登录人数"
          />
          <el-table-column
            prop="yeastDay"
            label="昨日登录人数"
          />
          <el-table-column
            prop="weekDay"
            label="上周当天登录人数"
          />
        </el-table>
      </template>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getLoginCountStat, getLoginStat1 } from '@/api/statistics/user_remain'
export default {
  name: 'IndexUserLoginCountAnalyze',
  props: {
    table: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      platForm: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }],
      country: [],
      chartData: {},
      queryParams1: {
        country: '',
        platForm: 0,
        startDate: '',
        endDate: '',
        type: 1
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (!this.queryParams1.startDate) {
        this.msgError('日期不能为空')
        return
      }
      this.initChart()
    },
    initChart() {
      const chart = echarts.init(this.$refs.chartContainer)
      chart.showLoading()
      const option = {
        color: ['red', '#00BFFF', '#FFA500'],
        title: {
          text: '累计登录'
        },
        legend: {
          data: ['今日', '昨日', '上周'],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '今日',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {
              // data: [
              //   { type: 'max', name: 'Max' },
              //   { type: 'min', name: 'Min' }
              // ]
            },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '昨日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '上周',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      chart.setOption(option)
      this.loading = true
      setTimeout(() => {
        getLoginCountStat(this.queryParams1).then(res => {
          this.loading = false
          chart.hideLoading()
          if (res.code === 200) {
            const date = res.data.timeLine
            const today = []
            const yestDay = []
            const weekDay = []
            const country = res.data.country
            if (date.length > 0) {
              date.forEach(item => {
                this.tableData.push({
                  time: item,
                  today: 0,
                  yeastDay: 0,
                  weekDay: 0
                })
              })
            }
            for (const i in res.data.todayData) {
              today.push(res.data.todayData[i])
              this.tableData[i].today = res.data.todayData[i]
            }
            for (const i in res.data.yestDayData) {
              yestDay.push(res.data.yestDayData[i])
              this.tableData[i].yeastDay = res.data.yestDayData[i]
            }

            for (const i in res.data.weekData) {
              weekDay.push(res.data.weekData[i])
              this.tableData[i].weekDay = res.data.weekData[i]
            }

            this.country = [{ value: '', label: '全部' }]
            for (const i in country) {
              this.country.push({ value: i, label: country[i] })
            }
            option.xAxis.data = date
            option.series[0].data = today
            option.series[1].data = yestDay
            option.series[2].data = weekDay
            chart.setOption(option, true)
            this.queryParams1.startDate = res.data.req.startDate
            // this.queryParams1.endDate = res.data.req.endDate
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>
<style scoped />
